import TileContent from "./TileContent.vue";
import { pluginify } from "./../../util";
export default pluginify(TileContent);
export { TileContent };
